import { render, staticRenderFns } from "./statisticsPage.vue?vue&type=template&id=732cd1f0&scoped=true&"
import script from "./statisticsPage.vue?vue&type=script&lang=ts&"
export * from "./statisticsPage.vue?vue&type=script&lang=ts&"
import style0 from "./statisticsPage.vue?vue&type=style&index=0&id=732cd1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cd1f0",
  null
  
)

export default component.exports